<template>
    <div class>
        <el-dialog
           :visible="true"
            @close="handleClose"
            :close-on-click-modal="false"
            width="800px"
            title="修改展业模式"
        >
            <el-card class="box-card" shadow="hover" v-loading="initLoading">
                <el-form
                    :inline="true"
                    :model="modeForm"
                    label-position="right"
                    label-width="140px"
                >
                    <template>
                        <div class="m-title">展业信息</div>
                        <el-form-item label="代理商昵称">
                            <el-input
                                size="medium"
                                suffix-icon="el-icon-aux"
                                disabled
                                v-model="modeForm.nickname"
                                placeholder="请输入代理商名称"
                            ></el-input>
                        </el-form-item>
						<el-form-item label="代理商姓名">
						    <el-input
						        size="medium"
						        disabled
						        suffix-icon="el-icon-aux"
						        v-model="modeForm.real_name"
						    ></el-input>
						</el-form-item>
						
                        <el-form-item label="展业模式">
                            <el-select
                                size="medium"
                                v-model="modeForm.mode_type"
                                placeholder="请选择展业模式"
                            >
                                <el-option label="档位模式" :value="1"></el-option>
                                <el-option label="自定义模式" :value="2"></el-option>
                            </el-select>
                        </el-form-item>
                        <br />
                        <el-form-item>
                            <el-button
                                type="primary"
                                :loading="loading"
                                style="font-size: 12px;"
                                @click="handleSubmit(modeForm)"
                            >保存设置</el-button>
                        </el-form-item>
                    </template>
                </el-form>
            </el-card>
        </el-dialog>
    </div>
</template>

<script>
export default {
    props: {
        info: {
            type: Object
        }
    },
    data() {
        return {
            initLoading: false, // 初始化loading
            loading: false, // 提交loading
            modeForm: {
                mode_type: this.info.mode_type, // 展业模式
                user_id: this.info.id,
				real_name:this.info.real_name,
				nickname:this.info.nickname,
            }
        }
    },
    created() {
        this.getData().then(() => {
            this.getBranch('init');
        })
        // this.getRole(); //获取代理商列表
        this.getBank(); //获取银行列表
    },
    mounted() {
    },
    methods: {
        handleClose(ref) {
            this.$emit('infoClose', ref)
        },
        handleSubmit(modeForm) { //后台提交
            this.loading = true; //防重复
                this.$api.post('user/upUserModeType', modeForm, res => {
                    let that = this;
                    if (res.code == 0) {
                        this.$message({
                            type: 'success',
                            message: res.msg,
                            duration: 1500,
                            onClose() {
                                that.loading = false; 
                                that.handleClose(1);
                            }
                        });
                    } else {
                        this.$message({
                            type: 'error',
                            message: res.msg,
                            duration: 1500,
                            onClose() {
                                that.loading = false;
                            }
                        });
                    }
                })
        },
         
    }
}
</script>

<style scoped lang="scss">
.el-form-item {
    margin-bottom: 22px;
}
.m-title {
    color: #303133;
    font-size: 14px;
    font-weight: 700;
    padding-left: 10px;
    margin: 10px 0;
    border-left: 4px solid #409eff;
}
</style>
